module.exports = __webpack_public_path__ + "img/trnct_daecheon.698d80d1.jpg";